export const AppRouting = {
	Error403: {
		path: () => "/403",
	},
	Error404: {
		path: () => "/404",
	},
	Home: {
		path: () => "/",
	},
	SignIn: {
		path: () => "/login",
	},
	AuthCallback: {
		path: () => "/auth/callback",
	},
	AuthLogoutCallback: {
		path: () => "/auth/logout-callback",
	},
	AdvisoryCase: {
		route: "/advisory-case/:advisoryCaseId",
		path: (advisoryCaseId: string) => `/advisory-case/${advisoryCaseId}`,
	},
	External: {
		Finam: {
			path: () => "/finam",
		},
		Elis: {
			path: () => "/elis",
		},
		Extranety: {
			path: () => "/extranety",
		},
		Zzj: {
			path: () => "/zzj",
		},
		InvestmentQuestionnaire: {
			path: () => "/investicny-dotaznik",
		},
	},
} as const;

type RouteObject<T extends any[] = any[]> = {
	route?: string;
	path: (...args: T) => string;
};

export function getRoute<T extends RouteObject>(routeObj: T): string {
	return routeObj.route ?? routeObj.path();
}

export function resolveStartPage(
	user: unknown | null,
	unauthenticatedUrl: string | null,
) {
	if (user === null) {
		return AppRouting.SignIn.path();
	}

	if (unauthenticatedUrl) {
		return unauthenticatedUrl;
	}
	return AppRouting.Home.path();
}

export function getPathnameAndSearch(location: {
	pathname: string;
	search: string;
}) {
	return `${location.pathname}${location.search}`;
}
